import { render, staticRenderFns } from "./AlternativeEditor.vue?vue&type=template&id=75ac5f1e"
import script from "./AlternativeEditor.vue?vue&type=script&lang=ts"
export * from "./AlternativeEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports